export default "__VITE_ASSET__DQPoG217__"